import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_663_6055)">
            <path
                d="M7.13174 2.52721C7.51563 1.85539 8.48433 1.85539 8.86822 2.52721L14.2835 12.0039C14.6644 12.6705 14.183 13.5 13.4152 13.5H2.58477C1.81694 13.5 1.33558 12.6705 1.71652 12.0039L7.13174 2.52721Z"
                stroke="currentColor"
            />
            <circle cx="8" cy="10.75" fill="currentColor" r="0.75" />
            <path
                d="M8 8.5V5.5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_663_6055">
                <rect fill="white" height="16" width="16" />
            </clipPath>
        </defs>
    </svg>
);

export default Icon;
